module.exports = __webpack_public_path__ + "static/media/b2b-huggg-logo.a0787db4.svg";